// libs
import React, { useState } from 'react';

import { cn } from '@lyearn/style';
// components
import { TextareaAutosize } from '@lyearn/ui';
import CellBackdrop from '@/modules/corporate/modules/database/fields/components/CellBackdrop';
// hooks
import useInputEvents from '@/modules/corporate/modules/database/fields/hooks/useInputEvents';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';

// styles
import { editableInputStyles, rectPositionStyles } from './styles';

const CLASSNAME =
  'fixed bg-bg-primary py-8 ps-12 rounded-4 body-short-02 text-text-paragraph focus:outline-none resize-none';

function TextEditable(props: CellProps) {
  const { column, cellData, toggleIsEditing, rowData, onAction } = props;
  const [value, setValue] = useState(cellData?.value);

  const onChange = (event: React.ChangeEvent<{ value: string }>) => {
    setValue(event.target.value);
  };

  const onClickAway = () => {
    if (value !== cellData?.value) {
      onAction({
        type: TableViewActionTypes.UpdateCellValue,
        // @ts-ignore
        payload: { fieldId: column.id, documentId: rowData._id, data: { value } },
      });
    }
    toggleIsEditing();
  };

  const { onKeyDown } = useInputEvents({ onClickAway });

  return (
    <CellBackdrop onClickAway={onClickAway}>
      {(rect) => (
        <TextareaAutosize
          autoFocus
          className={cn(CLASSNAME, editableInputStyles, rectPositionStyles(rect))}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      )}
    </CellBackdrop>
  );
}

export default TextEditable;
